import { getI18n } from "react-i18next";

export function localize (namespace, key)  {
  return getI18n().t(namespace + ":" + key);
}

export function loadNamespaces (namespaces) {
  return getI18n().loadNamespaces(namespaces);
}
  
//small wrapper to localize function that includes the namespace for this component
export const localizationNamespace = "MFALogin";
export function t (key) {
  return localize(localizationNamespace, key);
}